import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/navigation';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';

import { getIsNav4EnabledSafe } from './getIsNav4EnabledSafe';

export const useNavigateToTeamsApp = (
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const { cloudId, orgId } = useSessionData();
	const { push } = useRouteActions();
	const isNav4Enabled = getIsNav4EnabledSafe();

	return navigateToTeamsAppBase({
		push,
		hostProduct: 'confluence',
		orgId,
		cloudId,
		userHasNav4Enabled: isNav4Enabled,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};
